"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var dom_1 = require("../../runtime/dom");
var awsui_button_1 = require("../button/awsui-button");
var PopoverWrapper = /** @class */ (function (_super) {
    __extends(PopoverWrapper, _super);
    function PopoverWrapper() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PopoverWrapper.prototype.findTrigger = function () {
        return this.find('.awsui-popover__trigger');
    };
    PopoverWrapper.prototype.findHeader = function () {
        return this.find('.awsui-popover__header');
    };
    PopoverWrapper.prototype.findContent = function () {
        return this.find('.awsui-popover__content');
    };
    PopoverWrapper.prototype.findDismissButton = function () {
        return this.findComponent('.awsui-popover__dismiss-control', awsui_button_1.default);
    };
    return PopoverWrapper;
}(dom_1.ComponentWrapper));
exports.default = PopoverWrapper;
//# sourceMappingURL=awsui-popover.js.map